import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="mx-auto max-w-2xl px-4 py-24 text-center" data-testid="payment-cancel-page">
      <XCircle className="mx-auto h-14 w-14 text-[var(--pink)]" />
      <h1 className="mt-6 text-4xl sm:text-5xl">Checkout cancelled</h1>
      <p className="mt-3 text-white/60">No payment was taken. Your cart is still saved.</p>
      <Link to="/cart" className="btn-candy mt-8" data-testid="payment-cancel-cart-button">Back to cart</Link>
    </div>
  );
}
